import { combineTokens, makeSelectors } from '@utils/css';

const asideTokens = combineTokens("--aside", {
  leftAsideWidth: "300px",
  rightAsideWidth: "375px"
});

/**
 * breakpoint under which the aside will take over the entire screen.
 */
const ASIDE_TAKEOVER_BREAKPOINT_PX = 600;
const wrapperCls = "_61w1vcljpj";
const asideCls = "_61a1ham3nz";
const selectors = makeSelectors({
  wrapper: wrapperCls,
  aside: asideCls
});

export { ASIDE_TAKEOVER_BREAKPOINT_PX, asideCls, asideTokens, selectors, wrapperCls };
import "./Aside.linaria.module.css";
//# sourceMappingURL=Aside.js.map
